import {
  Flex,
  Box,
  Button,
  Grid,
  Text,
  AspectRatio,
  IconButton,
} from '@chakra-ui/react'
import { faTrashCan } from '@fortawesome/pro-light-svg-icons'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'

import PdfIcon from 'src/assets/icon/CustomPDFSVG'
import Icon from 'src/components/widgets/Icon'
import UploadTrigger from 'src/components/widgets/UploadTrigger/UploadTrigger'

export interface UploaderProps {
  fileName: string
  isDirty: boolean
  status: 'Required' | 'Saving...' | 'Saved'
  onDelete: () => Promise<void>
  onUpload: (ev: React.ChangeEvent<HTMLInputElement>) => Promise<void>
  accept?: string
}

const Uploader: React.FC<UploaderProps> = ({
  fileName,
  isDirty,
  status,
  onDelete,
  onUpload,
  accept = '*',
}) => (
  <Flex
    border="1px solid"
    borderRadius={12}
    borderColor="sandstone"
    p={4}
    flexDirection="row"
    justifyContent="space-between"
  >
    <Grid gridTemplateColumns="24px 1fr" gap={2}>
      <AspectRatio ratio={1 / 1} width="24px" height="24px" mt={2}>
        <PdfIcon />
      </AspectRatio>
      <Box>
        <Text fontWeight={600}>PDF</Text>
        <Text
          fontWeight={600}
          color="stone"
          className="input-label"
          data-testid="uploader-requiredLabel"
        >
          {status}
        </Text>
      </Box>
      {isDirty && (
        <>
          <Icon icon={faCheck} color="successful" ml={1} />
          <Text className="body-small" data-testid="uploader-fileName">
            {fileName}
          </Text>
        </>
      )}
    </Grid>
    <Box>
      {!isDirty && (
        <Box position="relative">
          <Button
            data-testid="uploader-input"
            variant="function"
            aria-label="Send document button"
          >
            Upload
          </Button>
          <UploadTrigger
            accept={accept}
            onChangeFile={onUpload}
            testid="documentBuilder-uploadDocument"
          />
        </Box>
      )}
      {isDirty && (
        <IconButton
          aria-label="Trash Document"
          variant="function"
          fontWeight={400}
          icon={<Icon icon={faTrashCan} />}
          width="36px"
          height="36px"
          onClick={onDelete}
        />
      )}
    </Box>
  </Flex>
)

export default Uploader
